<template>
  <v-card>
    <v-card-text>
      <form @submit.prevent="submit()">
        <component
          v-for="input in inputs" :key="input.key"
          :is="input.component"
          :config="input"
          v-model="$data[input.key]">
        </component>

        <AttachmentInput
          :directory="`${purchase.offer.service_type}_attachments`"
          v-model="attachments">
        </AttachmentInput>

        <v-card-row actions>
          <v-btn
            type="submit"
            primary light ripple
            :loading="loading">
            {{ $t('purchase.messageform.save') }}
          </v-btn>
        </v-card-row>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { TextInput, AttachmentInput } from '@/components/inputs'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      AttachmentInput
    },
    mixins: [purchase],
    data () {
      const answer = this.purchase.service.answer || {}
      return {
        error: {},
        title: answer.title || `RE: ${this.purchase.service.request.title}`,
        content: answer.content,
        attachments: answer.attachments
      }
    },
    computed: {
      inputs () {
        return [
          { key: 'title', component: TextInput },
          { key: 'content', required: true, component: TextInput, multiLine: true }
        ]
          .map(input => ({
            ...input,
            label: this.$t(`purchase.messageform.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      }
    },
    methods: {
      submit () {
        this.finish({
          title: this.title,
          content: this.content,
          attachments: JSON.stringify(this.attachments)
        })
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/MessageForm.vue